import QorusClient from "@/api/clients/QorusClient";
import Vue from "vue";
import Uicookie from "@/utils/cookie";
import { Customer } from "@/models/customer";
import { AxiosRequestConfig } from "axios";
import Locales from "@/utils/locales";
import Api from "@/api/Api";
import store from "@/store";

/**
 *  Qorus API about user's account
 */

export default class AccountService extends Vue {
  constructor() {
    super();
  }

  static of(): AccountService {
    return new AccountService();
  }

  login(customer: any): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().post("customers/sign-in", customer, axiosRequestConfig).then(
      (data: Customer) => {
        if (!data.twoFactorAuthenticationEnabled) {
          if (data.customerGroup !== "General public") {
            Uicookie.deleteCart();
          }
          Uicookie.setCustomerToken(data.JWT);
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  loginGpNet(customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,

      },
    };

    return QorusClient.of().post("gpnet/sign-in", customer, axiosRequestConfig).then(
      (data: Customer) => {
        if (!data.twoFactorAuthenticationEnabled) {

          Uicookie.setCustomerToken(data.JWT);
        }
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  removeCart(data) {
    if (data.shoppingCart && data.shoppingCart.id) {
      Api.cart.removeCart(data.shoppingCart?.id).then((data) => {
        store.dispatch("setCart", data).then();
      }).catch((e) => {
        console.log(e);
        store.dispatch("setCart", null).then();
        data.shoppingCart = null;
      });
    }
  }

  loginHabile(authorizationCode): Promise<Customer> {
    const isEmpowerment = sessionStorage.getItem("empowerment");
    let habileType = "AIR_FRANCE_EMPLOYEE";
    if (isEmpowerment) {
      habileType = "EMPOWERMENT";
    }

    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        authorizationCode,
        habileType,
        subdomain: "NONE",
      },
    };
    return QorusClient.of().get("habile", axiosRequestConfig).then(
      (data: Customer) => {
        Uicookie.setCustomerToken(data.JWT);
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        if (data.customerGroup === "Empowerment") {
          this.removeCart(data);
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) { // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
    return result;
  }

  fullyURIDecode(data) {
    while (data !== decodeURIComponent(data)) {
      data = decodeURIComponent(data);
    }
    return data;
  }

  loginEmpowerment(params): Promise<unknown> {
    /*const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        authorizationCode,
      },
    };*/
    let dataEmporwerment;

    try {
      dataEmporwerment = {
        data: {
          context: JSON.parse(this.fullyURIDecode(atob(params.context))),
          client: JSON.parse(this.fullyURIDecode(atob(params.client))),
        },
      };

      return new Promise<string>((resolve, reject) => {

        resolve(JSON.stringify(dataEmporwerment));
      }).then((data) => {

        sessionStorage.setItem("empowermentClient", data);
        sessionStorage.setItem("empowerment", "true");
        return data;
      })
        .catch((e) => {
          console.error(e);
          throw new Error("Something failed");
          // sessionStorage.removeItem("empowermentClient");
          //  sessionStorage.removeItem("empowerment");
        });
    } catch (e) {
      console.error(e);
      return new Promise<string>((resolve, reject) => {
        reject({ message: "JSON ERROR: " + e });
      });
    }

    /* return QorusClient.of().get("cbs", axiosRequestConfig).then(
        (data: Customer) => {
          Uicookie.setCustomerToken(data.JWT);
          return Customer.of(data);
        },
        data => {
          Uicookie.deleteCustomerToken();
          throw data;
        },
      );*/
  }

  checkAuth(customer: Customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().post("customers/one-time-password", {
      email: customer.email,
      password: customer.password,
      oneTimePassword: customer.oneTimePassword,
    }, axiosRequestConfig).then(
      (data: Customer) => {
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        Uicookie.setCustomerToken(data.JWT);
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  checkAuthGpnet(customer: Customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().post("gpnet/one-time-password", {
      email: customer.email,
      password: customer.password,
      oneTimePassword: customer.oneTimePassword,
    }, axiosRequestConfig).then(
      (data: Customer) => {
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        Uicookie.setCustomerToken(data.JWT);
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  register(customer: Customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };
    customer.locale = Locales.getLocaleCode();

    return QorusClient.of().post("customers/register", customer, axiosRequestConfig).then(
      (data: Customer) => {
        Uicookie.setCustomerToken(data.JWT);
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  registerGpNet(customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();

    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };
    customer.locale = Locales.getLocaleCode();

    return QorusClient.of().post("gpnet/register", customer, axiosRequestConfig).then(
      (data: Customer) => {
        Uicookie.setCustomerToken(data.JWT);
        if (data.customerGroup !== "General public") {
          Uicookie.deleteCart();
        }
        if (data.customerGroup !== "Empowerment") {
          sessionStorage.removeItem("empowerment");
          sessionStorage.removeItem("empowermentClient");
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  resetPassword(customer: any): Promise<void> {
    const email = customer.email ? customer.email : "";
    const recaptchaData = customer.recaptchaData ? customer.recaptchaData : "";
    /*const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        email,
        recaptchaData,
      },
    };*/
    return QorusClient.of().post("customers/reset-password", { email, recaptchaData }).then(
      (data: void) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  resetPasswordGpNet(customer: any): Promise<void> {
    const email = customer.email ? customer.email : "";
    const recaptchaData = customer.recaptchaData ? customer.recaptchaData : "";
    return QorusClient.of().post("gpnet/reset-password", { email, recaptchaData }).then(
      (data: void) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  logout(): void {
    sessionStorage.removeItem("empowerment");
    sessionStorage.removeItem("empowermentClient");
    sessionStorage.removeItem("configureEmpowerment");
    Uicookie.deleteCart();
    Uicookie.deleteCustomerToken();
  }

  getProfile(userToken: string): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const isEmpowerment = sessionStorage.getItem("empowerment");
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().get("customers/me", axiosRequestConfig).then(
      (data) => {
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  updateProfile(customer: Customer): Promise<any> {
    const params = {
      id: customer.id,
      firstName: customer.firstName,
      email: customer.email,
      lastName: customer.lastName,
      customerGroup: customer.customerGroup,
      birthDate: customer.birthDate,
      newsLetterSubscribed: customer.newsLetterSubscribed,
      locale: customer.locale,
      twoFactorAuthenticationEnabled: customer.twoFactorAuthenticationEnabled,
    };
    /* TODO send only form value not all customer information*/
    return QorusClient.of().patch("customers", params).then(
      () => {
        return;
      },
      err => {
        throw err;
      },
    );
  }

  updatePassword(passwords: { oldPassword: string, newPassword: string }): Promise<any> {

    return QorusClient.of().post("customers/change-password", passwords).then(
      () => {
        return;
      },
      err => {
        throw err;
      },
    );
  }

  addAddress(address): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {

      params: {
        defaultShipping: address.defaultShipping,
        defaultBilling: address.defaultBilling,
      },
    };
    return QorusClient.of().post("customers/address", address, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  removeAddress(addressName): Promise<any> { /* TODO */

    return QorusClient.of().delete("customers/address/" + addressName).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  changeResetPassword(params): Promise<any> {

    return QorusClient.of().post("customers/change-password/" + params.resetToken, {
      newPassword: params.newPassword,
      recaptchaData: params.recaptchaData,
    }).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  subscribeNewsletter(customerEmail): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        customerEmail,
      },
    };
    return QorusClient.of().put("customers/newsletter/subscribe", null, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  unSubscribeNewsletter(customerEmail): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        customerEmail,
      },
    };
    return QorusClient.of().put("customers/newsletter/unsubscribe", null, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

}